import type { ServiceItem } from '@/cms/fields/types/checkout-page'
import { BabyCotService } from '@/scopes/checkout/components/services/BabyCotService'
import { BikeRentalService } from '@/scopes/checkout/components/services/BikeRentalService'
import { BreakfastArrivalBusService } from '@/scopes/checkout/components/services/BreakfastArrivalBusService'
import { BreakfastService } from '@/scopes/checkout/components/services/BreakfastService'
import { BusService } from '@/scopes/checkout/components/services/BusService'
import { CancellationInsuranceService } from '@/scopes/checkout/components/services/CancellationInsuranceService'
import { SweaterService, TShirtService } from '@/scopes/checkout/components/services/ClothingService'
import { ComedyService } from '@/scopes/checkout/components/services/ComedyService'
import { DinnerService } from '@/scopes/checkout/components/services/DinnerService'
import { DutchweekService } from '@/scopes/checkout/components/services/DutchweekService'
import { DutchweekValThorensService } from '@/scopes/checkout/components/services/DutchweekValThorensService'
import { EsimService } from '@/scopes/checkout/components/services/EsimService'
import { GenericService } from '@/scopes/checkout/components/services/GenericService'
import { MealplanDPService } from '@/scopes/checkout/components/services/MealplanDPService'
import { MealplanExternalService } from '@/scopes/checkout/components/services/MealplanExternalService'
import { MealplanService } from '@/scopes/checkout/components/services/MealplanService'
import { ParkingAirportService } from '@/scopes/checkout/components/services/ParkingAirportService'
import { PartyTicketsService } from '@/scopes/checkout/components/services/PartyTicketsService'
import { RebookingService } from '@/scopes/checkout/components/services/RebookingService'
import { SkiCarriageService } from '@/scopes/checkout/components/services/SkiCarriageService'
import { SkiTransferService } from '@/scopes/checkout/components/services/SkiTransferService'
import { TransferService } from '@/scopes/checkout/components/services/TransferService'
import { TravelInsuranceService } from '@/scopes/checkout/components/services/TravelInsuranceService'
import { VisaService } from '@/scopes/checkout/components/services/VisaService'
import React from 'react'

const genericServiceMap = {
  'BUS': BusService,
  'TSHIRT*': TShirtService,
  'SWEATER*': SweaterService,
  'CARRIAGESKI*': SkiCarriageService,
  'SHAREDBUS': SkiTransferService,
  'COMEDY': ComedyService,
  'VERZORGING*': MealplanService,
  'ACCOMMODATION': MealplanDPService,
  'HALFBOARD*': MealplanExternalService,
  'BREAKFAST': BreakfastService,
  'DINNER': DinnerService,
  'BREAKFARRHINT_00': BreakfastArrivalBusService,
  'TRAVEL*': TravelInsuranceService,
  'DUTCHWEEK': DutchweekService,
  'DUTCHWEEK1': DutchweekValThorensService,
  'PARTY*': PartyTicketsService,
  'ESIM': EsimService,
  'FIETS': BikeRentalService,
  'TRANSFER': TransferService,
  'REBOOKING': RebookingService,
  'BABY*': BabyCotService,
  'PARKEREN': ParkingAirportService,
  'VISA*': VisaService,
  'CANCEL*': CancellationInsuranceService,
}

function renderServiceUsingGenericServiceComponent(aName: string) {
  return ['TRANSFER', 'REBOOKING', 'BABY*', 'PARKEREN', 'VISA*', 'FIETS', 'ESIM'].includes(aName)
}

export function getGenericServiceComponent(aName: string, item: ServiceItem, type: string, index: number) {
  const key = `${type}-${aName}-${index}`

  for (const [pattern, Component] of Object.entries(genericServiceMap)) {
    const isMatch = aName.startsWith(pattern.replace('*', '')) || aName === pattern
    if (!isMatch)
      continue

    if (renderServiceUsingGenericServiceComponent(aName)) {
      return <GenericService item={item} key={key} />
    }
    return <Component key={key} />
  }

  return <GenericService item={item} key={key} />
}
